import { Modal, ModalHeader, ModalBody, Button } from '@evertrue/et-components';
import { useOpenClose } from '@evertrue/sdk';
import PropTypes from 'prop-types';

const ViewAllModal = ({ handleBulkViewClick = () => {} }) => {
  const [isOpen, openModal, closeModal] = useOpenClose();
  const handleClick = async () => {
    await handleBulkViewClick();
    closeModal();
  };

  return (
    <>
      <Button type="secondary" onClick={openModal}>
        Mark All as Viewed
      </Button>

      <Modal isOpen={isOpen} closeModal={closeModal} size="small">
        <ModalHeader title="Mark All as Viewed" />
        <ModalBody>Are you sure you want to mark all recommended actions as viewed?</ModalBody>
        <div className="confirm-modal-actions">
          <Button type="simple" onClick={closeModal}>
            Cancel
          </Button>
          <div style={{ margin: '0 20px' }}>
            <Button onClick={handleClick}>Mark All as Viewed</Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

ViewAllModal.propTypes = {
  handleBulkViewClick: PropTypes.func.isRequired,
};

export default ViewAllModal;
